import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'narwhalia-crispr',
  templateUrl: './crispr.component.html',
  styleUrls: ['./crispr.component.scss']
})
export class CrisprComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
